import { Routes, Route } from 'react-router-dom';
import { Login } from '../../Auth/Login';
import { Registration } from '../../Auth/Registration';
import { ForgotPassword } from '../../Auth/ForgotPassword';
import { CreatePassword } from '../../Auth/CreatePassword';
import RegistrationSuccessfullPage from '../../Auth/RegistrationSuccessfullPage';
 
export const AuthRoutes = () => {

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Login />} />
      <Route path="/register" element={<Registration />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/create-password/:org_code/:token/:user_id?" element={<CreatePassword />} />
      <Route path='/registrationSuccessful' element={<RegistrationSuccessfullPage/>}/>
    </Routes>

  );
};